import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import CxSearcher from '../../cx/CxSearcher';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';
import CxIconButton from '../../cx/CxIconButton';
//import { useNav } from '../../hx/useNav';


const MxSettAnimalMergeSpeciesForm = (props) => {
  const [{ trans }] = useTranslation();
  //const [{ navBack }] = useNav();
  const r_snack_required = React.useRef(null);
  const r_snack_same_item = React.useRef(null);
  const r_snack_op_in_progress = React.useRef(null);
  const r_snack_op_successful = React.useRef(null);
  let r_form = React.useRef(null);

  const rf_txTypeAnimalSpeciesToKeep = React.useRef(null);
  const rf_txTypeAnimalSpeciesToDelete = React.useRef(null);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);
  
  const doMerge = () => {
    // chequea requeridos
    if (rf_txTypeAnimalSpeciesToKeep.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypeAnimalSpeciesToKeep.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txTypeAnimalSpeciesToDelete.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypeAnimalSpeciesToDelete.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txTypeAnimalSpeciesToKeep.current.getKey()===rf_txTypeAnimalSpeciesToDelete.current.getKey()) {
      r_snack_same_item.current.setOpen(true);
      return;
    }
    
    let itAnimalSpecies_toKeep = rf_txTypeAnimalSpeciesToKeep.current.getKey();
    let itAnimalSpecies_toDelete = rf_txTypeAnimalSpeciesToDelete.current.getKey();

    let record = {};
    record['itAnimalSpecies_toKeep'] = itAnimalSpecies_toKeep;
    record['itAnimalSpecies_toDelete'] = itAnimalSpecies_toDelete;
    r_snack_op_in_progress.current.setOpen(true);
    Promise.all([FxFetch.doJsonX(`sett/animal/merge/species/do`, record)]).then((result) => {
      rf_txTypeAnimalSpeciesToKeep.current.clear();
      rf_txTypeAnimalSpeciesToDelete.current.clear();
      r_snack_op_in_progress.current.setOpen(false);
      r_snack_op_successful.current.setOpen(true);
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.merge_x', 'field.species_p')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButton type="issue" classType="ibs_iconbutton_toolbar" onClick={doMerge} tooltip={trans('field.merge_duplicates')} />
          </div>
        }
      >

      <CxSearcher xref={rf_txTypeAnimalSpeciesToKeep}
        label={trans('field.keep')}
        url="sett/animal_species" 
        col_id="itAnimalSpecies" 
        col_tx="txTypeAnimalSpecies"
        tooltip={`${trans('field.species')}`}
        columns={[
          { id: "0", Header: "ID", accessor: "itAnimalSpecies", show: false },
          { id: "1", Header: trans('field.species'), accessor: row => rf_txTypeAnimalSpeciesToKeep.current.getTable().highlightText(row["txTypeAnimalSpecies"]), width: '30%' },
        ]}
        width='var(--ibs_control_width_md)'
        required
      />

      <CxSearcher xref={rf_txTypeAnimalSpeciesToDelete}
        label={trans('field.delete')}
        url="sett/animal_species" 
        col_id="itAnimalSpecies" 
        col_tx="txTypeAnimalSpecies"
        tooltip={`${trans('field.species')}`}
        columns={[
          { id: "0", Header: "ID", accessor: "itAnimalSpecies", show: false },
          { id: "1", Header: trans('field.species'), accessor: row => rf_txTypeAnimalSpeciesToDelete.current.getTable().highlightText(row["txTypeAnimalSpecies"]), width: '30%' },
        ]}
        width='var(--ibs_control_width_md)'
        required
      />

      </GxForm>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_same_item} severity="error" value={trans('msg.same_item')} />
      <CxSnackbar xref={r_snack_op_in_progress} severity="info" value={trans('msg.operation_in_progress')} autoHideDuration={10000} />
      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />
    </div>
  );

}

export default MxSettAnimalMergeSpeciesForm;
